import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useLibraryManager } from '@stores/LibraryManager/LibraryManager';
import css from './MediaPill.module.scss';

export const MediaPill = () => {
  const libraryManager = useLibraryManager();

  const handleClose = () => {
    libraryManager.multiLibSearch.setMediaId(null);
  };

  return (
    <div className={css.mediaPill}>
      <div className={css.mediaPillContent}>
        <span>Media</span>
        <span className={css.mediaId}>{libraryManager.multiLibSearch.mediaId}</span>
        <div className={css.closeButton} onClick={handleClose}>
          <CloseRoundedIcon sx={{ fontSize: '18px' }} />
        </div>
      </div>
    </div>
  );
};
